<template>
  <div>
    <label-question :position="labelPos" :text="data.label" />
    <label-answer
      @click="onSelect(index)"
      :position="button.position"
      :text="button.label"
      v-for="(button, index) in buttons"
      :key="index"
      :state="button.state"
    />
    <loading-bar :progress="progress" />
  </div>
</template>

<script>
import LabelQuestion from '@/components/3D/LabelQuestion'
import LabelAnswer from '@/components/3D/LabelAnswer'
import LoadingBar from '@/components/3D/LoadingBar'
import { toScreenPosition } from '@/utils/Maths'

import { webGL } from '@/webGL/WebGL'

export default {
  components: {
    LabelQuestion,
    LabelAnswer,
    LoadingBar
  },

  computed: {
    labelPos () {
      return this.$store.getters['global/labelPos']
    }
  },

  data () {
    return {
      buttons: [],
      progress: 0
    }
  },

  props: {
    data: {
      type: Object,
      default: () => {return {}}
    },
    bumpers: {
      type: Array,
      default: () => {return []}
    },
    time: {
      type: Number,
      default: 0
    }
  },

  created () {
    this.elapsed = 0
    this.startTime = this.time
  },

  mounted () {
    this.bumpers.forEach((bumper, index) => {
      bumper.click = this.onSelect

      if (this.data.answers[index]) {
        bumper.state = 1
      }
      else {
        bumper.state = 0
      }

      if (this.data.answers[index]) {
        this.$set(this.buttons, index, {
          label: this.data.answers[index].label,
          position: {x: 0, y: 0, z:0},
          state: 0
        })
      }
    })

    this.onResize()
  },

  beforeDestroy() {
    this.bumpers.forEach((bumper, index) => {
      bumper.state = 0
    })
  },

  methods: {
    onResize () {
      this.bumpers.forEach((bumper, index) => {
        if (this.data.answers[index]) {
          const pos = toScreenPosition(bumper.basePos[0].clone().multiplyScalar(70), webGL.camera, this.$device.width, this.$device.height)
          this.buttons[index].position = pos
        }
      })
    },

    onUpdate () {
      this.elapsed = this.time - this.startTime
      this.progress = this.elapsed/this.data.duration

      if (this.elapsed > this.data.duration) {
        this.$emit('end')
      }
    },

    onSelect (index) {
      if (index === this.data.answers.findIndex(answer => answer.value)) {
        this.$store.commit('data/incrementScore', 1)
      }
      else {
        this.$store.commit('data/incrementScore', 0)
      }

      this.bumpers.forEach((bumper, i) => {
        if (bumper.state === 1 || bumper.state === 2) {
          if (index === i) {
            if (this.data.answers[index].value) {
              bumper.state = 3
            }
            else {
              bumper.state = 4
            }
          }
          else {
            bumper.state = 1
          }
        }
      })

      this.data.answers.forEach((answer, index) => {
        this.buttons[index].state = answer.value ? 1 : 2
      })
    }
  }
}  
</script>

<style lang="stylus">

</style>